import React from 'react';
import Container from '../../components/UI/Container/Container';
import { Typography } from 'antd';
import Headline from '../../components/UI/Headline/Headline';
import Button from '../../components/UI/Button/Button';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';

const PaymentInStore = ({ onHome, orderId }) => {
  const { t } = useTranslation();

  return (
    <Container style={{ marginTop: 190 }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 40
        }}
      >
        <Headline>{t('pages.orderCreated.title')}</Headline>
        <Typography
          style={{ fontSize: 30, fontWeight: 700, textAlign: 'center' }}
        >
          {t('pages.orderCreated.thanks')}
        </Typography>
        <Typography style={{ fontSize: 24, textAlign: 'center' }}>
        {t('pages.orderCreated.orderId')}: <strong>{orderId}</strong>
        </Typography>
        <Typography style={{ fontSize: 24, textAlign: 'center' }}>
          {parse(t('pages.orderCreated.shop'))}{' '}
        </Typography>
        <Button onClick={onHome}>{t('pages.orderCreated.button')}</Button>
      </div>
      <Typography style={{ color: 'rgba(184, 181, 182, 1)', textAlign: 'center', fontSize: 20, fontWeight: 400, marginTop: 40}}>
        {t('pages.orderCreated.questions')}{' '}
        <a href='mailto:info@tigsipay.com' style={{textDecoration: 'underline', color: 'rgba(88, 66, 113, 1)'}}>{t('button.contact')}</a>
      </Typography>
    </Container>
  );
};

export default PaymentInStore;
